(() => {
  if (!customElements.get('product-sticky')) {
    customElements.define(
      'product-sticky',
      class ProductSticky extends HTMLElement {
        constructor() {
          super();

          /*
          document.addEventListener('DOMContentLoaded', () => {
            this.init();
          });
          */

          this.init();

          document.addEventListener('reloadProductPage', () => {
            setTimeout(() => {
              this.init();
            }, 1000);
          });
        };

        init() {
          this.realAddToBag = document.querySelector('[data-add-to-cart]');
          this.productSizes = document.querySelector('[data-product-sizes]');

          this.sticky = document.querySelector('[data-product-sticky]');
          this.waypoint = document.querySelector('[data-product-sticky-waypoint]');
          this.selectWrap = this.sticky.querySelector('[data-select-wrap]');
          this.selectToggle = this.sticky.querySelector('[data-select-toggle]');
          this.selectOptions = this.sticky.querySelector('[data-select-options]');
          this.selectCurrent = this.sticky.querySelector('[data-select-current]');
          this.addToBag = this.sticky.querySelector('[data-sticky-atc]');

          this.priceWrap = this.sticky.querySelector('[data-price-wrap]');
          this.currency = this.sticky.querySelector('[data-shop-currency]');
          this.price = this.sticky.querySelector('[data-price]');
          this.comparePrice = this.sticky.querySelector('[data-compare-price]');
          this.percentSavings = this.sticky.querySelector('[data-percent-savings]');
          this.shippingBar = this.sticky.querySelector('[data-product-sticky-shipping]');
          this.shippingBarClose = this.sticky.querySelector('[data-product-sticky-shipping-close]');

          this.body = document.body;
          this.breakpoint = window.matchMedia('(min-width: 768px)');

          if (this.productSizes) {
            this.fillSizes();
            this.events();
            this.toggleVisibility();
            this.addToCart();
            this.state();

            this.shippingMessage();
            window.addEventListener('minicart::cartTotal', () => {
              this.shippingMessage();
            });
          }
        };

        state() {
          const sizes = document.querySelector('.product__select-sizes-item.active')
          if (!sizes) {
            this.addToBag.textContent = 'SELECT A SIZE'
          } else {
            const available = this.addToBag.getAttribute('data-available')
            if (available == 'true') {
              this.addToBag.removeAttribute('disabled')
            }
          }
        }

        fillSizes() {
          const emailIcon = `
            <svg role="presentation" aria-hidden="true" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0971 9.15002H1.20306C0.90785 9.13222 0.631607 8.99858 0.434414 8.77816C0.237221 8.55775 0.135029 8.26839 0.150063 7.97303V1.32803C0.134757 1.03249 0.236827 0.742876 0.434047 0.522243C0.631268 0.301611 0.907668 0.167827 1.20306 0.150024H10.0971C10.3925 0.167827 10.6689 0.301611 10.8661 0.522243C11.0633 0.742876 11.1654 1.03249 11.1501 1.32803V7.97303C11.1651 8.26839 11.0629 8.55775 10.8657 8.77816C10.6685 8.99858 10.3923 9.13222 10.0971 9.15002V9.15002ZM1.20306 0.697025C1.04475 0.706315 0.896545 0.777904 0.790859 0.896145C0.685172 1.01439 0.630597 1.16966 0.639063 1.32803V7.97303C0.630597 8.13139 0.685172 8.28666 0.790859 8.4049C0.896545 8.52314 1.04475 8.59474 1.20306 8.60403H10.0971C10.2554 8.59474 10.4036 8.52314 10.5093 8.4049C10.615 8.28666 10.6695 8.13139 10.6611 7.97303V1.32803C10.6695 1.16966 10.615 1.01439 10.5093 0.896145C10.4036 0.777904 10.2554 0.706315 10.0971 0.697025H1.20306Z" fill="black" stroke="black" stroke-width="0.3"/>
              <path d="M5.66802 5.19205C5.53425 5.19172 5.40278 5.1573 5.28602 5.09205L0.666016 2.53705L0.857016 2.03705L5.47802 4.59904C5.53613 4.63191 5.60175 4.64918 5.66852 4.64918C5.73528 4.64918 5.8009 4.63191 5.85902 4.59904L10.469 2.04905L10.66 2.54905L6.05002 5.09904C5.93262 5.1619 5.80117 5.19391 5.66802 5.19205Z" fill="black" stroke="black" stroke-width="0.3"/>
            </svg>
          `.trim();

          let sizeSelection = '';
          const lowerTags = window.productData.tags.map(tag => tag.toLowerCase());
          let isPetite = false;
          let isTall = false;
          if (lowerTags.includes('princess polly petite')) {
            isPetite = true;
          }
          if (lowerTags.includes('princess polly tall')) {
            isTall = true;
          }
          const sizes = document.querySelector('select[data-single-option-selector="size"]');
          for (const option of sizes) {
            const value = option.value;
            let label = value.replace('external-', '').replace(/iPhone/ig, '').replace(/shoe/ig, '');
            if (isPetite) {
              label += 'P';
            }
            if (isTall) {
              label += 'T';
            }
            const stock = Number(option.dataset.stock);
            if (option.dataset.variantId) {
              let classes = '';
              if (stock < 1) {
                classes = ' class="disabled"';
              }

              if (option.selected) {
                this.selectCurrent.textContent = label;
              }

              sizeSelection += `
                <li${classes}>
                  <button
                    type="button"
                    data-value="${value}"
                    data-variant-id="${option.dataset.variantId}"
                    data-select-option
                  >
                    <span>${label}</span>
                    ${stock < 1 ? emailIcon : ''}
                  </button>
                </li>
              `;
            }
          }

          this.selectOptions.innerHTML = sizeSelection;
        };

        addToCart() {
          /*
          const lityTemplate = `
          <div class="lity lity-sticky-bis" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1">
            <div class="lity-wrap" data-lity-close role="document">
              <div class="lity-loader" aria-hidden="true">Loading...</div>
              <div class="lity-container">
                <div class="lity-content"></div>
                <button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button>
              </div>
            </div>
          </div>`.trim()
          */

          const handleClick = (e) => {
            if (this.addToBag.dataset.available === 'true') {
              const addToBag = document.querySelector('[data-add-to-cart]');
              addToBag.click();
            } else {
              const bisEmail = document.querySelector('#bis-email');
              const bisButton = document.querySelector('[data-bis-button]');
              if (bisEmail) {
                bisEmail.focus();
              }
              if (bisButton) {
                bisButton.click();
              }
            }
          };

          this.addToBag.addEventListener('click', (e) => {
            e.preventDefault();
            handleClick(e);
          });
        };

        events() {
          this.selectToggle.addEventListener('click', (e) => {
            e.preventDefault();
            this.selectWrap.classList.toggle('active');
          });

          document.addEventListener('click', (e) => {
            if (!e.target.closest('[data-select-wrap]')) {
              this.selectWrap.classList.remove('active');
            }
          });

          if (this.shippingBar) {
            this.shippingBarClose.addEventListener('click', (e) => {
              e.preventDefault();
              this.shippingBar.classList.remove('active');
            });
          }

          const selectOptions = this.selectOptions.querySelectorAll('[data-select-option]');
          selectOptions.forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault();
              const realSize = this.productSizes.querySelector(`[data-size-variant-id="${el.dataset.variantId}"][data-size-value="${el.dataset.value}"]`);
              if (realSize) {
                realSize.dispatchEvent(new Event('click', { bubbles: true }));
              }
            });
          });

          window.subscribe(PUB_SUB_EVENTS.variantChange, e => {
            if (e.detail.variant) {
              const variant = e.detail.variant;
              const lowerTags = window.productData.tags.map(tag => tag.toLowerCase());
              let isPetite = false;
              let isTall = false;
              if (lowerTags.includes('princess polly petite')) {
                isPetite = true;
              }
              if (lowerTags.includes('princess polly tall')) {
                isTall = true;
              }
              this.selectCurrent.textContent = variant.option1.replace('external-', '').replace(/iPhone/ig, '').replace(/shoe/ig, '');
              if (isPetite) {
                this.selectCurrent.textContent += 'P';
              }
              if (isTall) {
                this.selectCurrent.textContent += 'T';
              }

              this.addToBag.textContent = variant.available ? this.addToBag.dataset.text : this.addToBag.dataset.textNotify;
              this.addToBag.dataset.available = variant.available;

              /* pricing updates */
              this.price.textContent = window.Shopify.formatMoney(variant.price, window.theme.moneyFormat || '${{amount}}');
              if (variant.compare_at_price > variant.price) {
                this.priceWrap.classList.add('sale');
                this.comparePrice.textContent = window.Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat || '${{amount}}');
                this.percentSavings.textContent = Math.round(100 - ((variant.price / variant.compare_at_price) * 100)) + '% off';
              } else {
                this.priceWrap.classList.remove('sale');
                this.comparePrice.textContent = '';
                this.percentSavings.textContent = '';
              }
            }
          })
        };

        toggleVisibility() {
          window.addEventListener('scroll', () => {
            if (window.scrollY < this.waypoint.offsetTop) {
              this.sticky.classList.remove('active');
              this.selectWrap.classList.remove('active');
              this.body.classList.remove('product-sticky--active');
            } else {
              this.sticky.classList.add('active');
              this.body.classList.add('product-sticky--active');
            }
          }, { passive: true });

          /* edge case if they are at the bottom of the screen on page load */
          window.addEventListener('load', () => {
            if (window.scrollY > this.waypoint.offsetTop) {
              this.sticky.classList.add('active');
              this.body.classList.add('product-sticky--active');
            }
          });

          /*
          const observer = new IntersectionObserver((entries) => {
            const entry = entries[0]
            if (entry.isIntersecting || entry.boundingClientRect.y > 0) {
              this.sticky.classList.remove('active')
              this.selectWrap.classList.remove('active')
              this.body.classList.remove('product-sticky--active')
            } else {
              this.sticky.classList.add('active')
              this.body.classList.add('product-sticky--active')
            }
          }, {
            threshold: 0.1
          })

          observer.observe(this.productSizes)
          */
        };

        backInStockForm() {
          /*
          const el = document.querySelector('.lity [data-bis-sticky]');
          const error = el.querySelector('[data-bis-error]');
          const form = el.querySelector('[data-bis-form]');
          const input = el.querySelector('[data-bis-input]');
          const thanks = el.querySelector('[data-bis-thank-you]');

          input.focus();

          const handleForm = () => {
            const sizeSelect = document.querySelector('select[data-single-option-selector="size"]');
            const selectedIndex = sizeSelect.querySelector('option:selected');
            const productId = parseInt(selectedIndex.getAttribute('data-product-id'));
            const variantId = parseInt(selectedIndex.getAttribute('data-variant-id'));

            BIS
              .create(input.val(), variantId, productId, { accepts_marketing: true })
              .then((resp) => {
                if (resp.status === 'OK') {
                  if (form.classList.contains('active')) form.classList.remove('active');
                  thanks.classList.add('active');
                  input.value = input.getAttribute('data-bis-input');
                } else {
                  error.innerHTML = '<span>We got you and you\'re on the list!</span>';
                }
              });
          };

          window.addEventListener('keyup', (e) => {
            if (e.target.matches('[data-bis-input]')) {
              const keycode = e.keyCode ? e.keyCode : e.which;

              if (keycode === 13 && input.value.includes('@') && input.value.includes('.')) {
                error.innerHTML = '';
                handleForm();
              }
            }
          });

          document.addEventListener('click', (e) => {
            if (e.target.matches('[data-bis-submit]')) {
              if (input.value.includes('@') && input.value.includes('.')) {
                error.innerHTML = '';
                handleForm();
              }
            }
          });
          */
        };

        shippingMessage() {
          if (this.shippingBar) {
            /* TODO: shippingDifference
            const shippingDifference = Number(window.VueMiniCart.shippingDifference);
            const productPrice = Number(this.price.dataset.price) / 100.0;

            if (shippingDifference > 0 && productPrice >= shippingDifference) {
              this.shippingBar.classList.add('active');
            } else {
              if (this.shippingBar.classList.contains('active')) {
                this.shippingBar.classList.remove('active');
              }
            }
            */
          }
        };
      }
    )
  }
})();